export const tableFields = [
  {
    field: 'load_date',
    name: 'День',
    subName: 'погрузки',
    action: 'linkToDay',
  },
  {
    field: 'date_load',
    name: 'Дата',
    subName: 'погрузки',
    action: 'linkToDay',
  },
  {
    field: 'date_unload',
    name: 'Дата',
    subName: 'выгрузки',
    action: 'linkToDay',
  },
  { field: 'marka', name: 'Марка', width: 60, action: 'Passport' },
  { field: 'num', name: 'Гос.номер', action: 'Passport' },
  { field: 'pricep', name: 'Прицеп', action: 'Passport' },
  {
    field: 'contragent_name',
    name: 'Имя перевозчика',
    width: 250,
    action: 'contragent',
  },
  { field: 'inn', name: 'ИНН', width: 100, action: 'contragent' },
  { field: 'driver', name: 'Водитель', width: 250, action: 'Driver' },
  {
    field: 'tara_pog',
    name: 'Тара',
    subName: 'погруж',
    width: 60,
    action: 'Ttn',
  },
  {
    field: 'ves_n_pog',
    name: 'Вес',
    subName: 'НЕТТО',
    width: 60,
    action: 'Ttn',
  },
  { field: 'brutto_pog', name: 'Брутто', width: 60, action: 'Ttn' },
  {
    field: 'tara_vig',
    name: 'Тара',
    subName: 'выгруж',
    width: 60,
    action: 'Ttn',
  },
  {
    field: 'ves_n_vig',
    name: 'Вес',
    subName: 'НЕТТО',
    width: 60,
    action: 'Ttn',
  },
  { field: 'brutto_vig', name: 'Брутто', width: 60, action: 'Ttn' },
  { field: 'num_ttn', name: 'Номер ТТН', width: 90, action: 'Ttn' },
  { field: 'akt_num', name: 'АКТ', width: 60, action: 'Act' },
  {
    field: 'dop',
    name: 'Доп',
    subName: 'расходы',
    width: 60,
    action: 'Payment',
  },
  { field: 'avance', name: 'Аванс', width: 60, action: 'Payment' },
  {
    field: 'sum_response',
    name: 'Сумма',
    subName: 'ТТН',
    width: 60,
    action: 'Payment',
  },
  {
    field: 'payments_sum',
    name: 'Сумма',
    subName: 'всего',
    width: 60,
    action: 'Payment',
  },
  { field: 'payments_left', name: 'Остаток', width: 65, action: 'Payment' },
  {
    field: 'status_pay',
    name: 'Статус',
    subName: 'оплачено',
    width: 65,
    action: 'Payment',
  },
  { field: 'data_oplata', name: 'Дата', subName: 'оплаты', action: 'Payment' },
  { field: 'napravl', name: 'Направление', width: 250, action: 'Direction' },
  {
    field: 'freight_price',
    name: 'Стоимость',
    subName: 'зерна',
    width: 70,
  },
  { field: 'nedovos', name: 'Недовоз' },
  {
    field: 'nedovos_possible',
    name: 'Допусти',
    subName: 'мый',
    width: 60,
  },
  { field: 'shtraf', name: 'Штраф' },
  {
    field: 'rastoyanie',
    name: 'рассто',
    subName: 'яние',
    width: 60,
  },
  {
    field: 'price_driver',
    name: 'Цена',
    subName: 'водителя',
    width: 65,
  },
  {
    field: 'price_bidder',
    name: 'Цена',
    width: 60,
  },
  { field: 'profit', name: 'Заработок', width: 65 },
]

export const perPageOptions = [5, 10, 20, 50, 100]

export const dateFilters = [
  { field: 'date_from', text: 'дата с' },
  { field: 'date_to', text: 'дата по' },
]

export const singleColums = [
  'tara_pog',
  'ves_n_pog',
  'brutto_pog',
  'tara_vig',
  'ves_n_vig',
  'brutto_vig',
  'num_ttn',
]

export const registerMenuItems = [
  {
    name: 'DialogAddPrepayment',
    title: 'Аванс',
    type: 'modal',
    typePayment: 1,

  },
  {
    name: 'DialogAddAdditional',
    title: 'Доп. расход',
    type: 'modal',
    typePayment: 2,
  },
  {
    name: 'DialogAddEstimation',
    title: 'Окончательный расчет',
    type: 'modal',
    typePayment: 0,
  },
]
